<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton v-if="providersOptions.length > 2" :color="filters ? 'dark' : 'warning'" size="sm" @click="toggleFilters" style="height: 26px; padding: 2px 5px;"><CIcon name="cil-filter"/></CButton>
          <CButton color="info" size="sm" @click="storeModal()" v-if="permissions && permissions['challenges.write'] === true">Nuevo Concurso</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="filters">
        <CCol md="3"></CCol>
        <CCol md="3"></CCol>
        <CCol md="3"></CCol>
        <CCol md="3">
          <div v-if="providersOptions.length > 2" role="group" class="form-group" style="margin: -10px 0px 10px">
            <label> Proveedor:</label>
            <CSelect
              :value.sync="providerSelected" 
              :options="providersOptions"
              @change="changeFilters"
            />            
          </div>
        </CCol>
      </CRow>
      <CDataTable
        :tableFilter="tableFilter"
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="30"
        :dark="dark"
        pagination
      >
        <template #code="{item}"><td class="w100 text-center">{{(item.code) ? item.code : '-'}}</td></template>
        <template #provider_name="{item}"><td class="text-center w200">{{item.provider_name ? item.provider_name : 'NO DEFINIDO'}}</td></template>
        <template #type="{ item }">
          <td class="w200 text-center">
            <span>{{ typeLabel(item.type) }}</span>
          </td>
        </template>        
        <template #name="{item}"><td>
          <span style="font-weight: bold;">{{item.name}}</span><br />
          <span>{{item.description}}</span>
        </td></template>
        <template #deadline="{item}"><td class="w300 text-center"><span>{{item.start_date | date}} - {{item.end_date | date}}</span></td></template>
        <template #is_active="{item}"><td class="w100 text-center">
          <span>
            <CButton v-if="item.is_active" color="success" size="sm" @click="permissions && permissions['challenges.write'] === true && deactiveProcess(item.id)"><CIcon name="cil-check"/></CButton>
            <CButton v-if="!item.is_active" color="danger" size="sm" @click="permissions && permissions['challenges.write'] === true && reactiveProcess(item.id)"><CIcon name="cil-ban"/></CButton>
          </span>
        </td></template>
        <template #actions="{item}">
          <td class="table_actions b3">
            <CButton color="info" size="sm" @click="showChallenge(item)"><CIcon name="cil-zoom"/></CButton>
            <CButton color="warning" size="sm" @click="updateModal(item)" v-if="permissions && permissions['challenges.write'] === true"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)" v-if="permissions && permissions['challenges.write'] === true"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <ChallengeModal ref="challengeModal" @store="storeProcess" @update="updateProcess"></ChallengeModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import ChallengeModal from './ChallengeModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ws from '../../services/challenges';
import providers_ws from '../../services/providers';
import store from '../../store'
import router from '../../router/index'

export default {
  name: 'ChallengesTable',
  components: { ChallengeModal, DeleteModal },
  props: {
    items: Array,
    permissions: Object,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'code', label: 'Folio'},
          {key: 'provider_name', label: 'Proveedor'},
          {key: 'type', label: 'Tipo'},
          {key: 'name', label: 'Nombre'},
          {key: 'deadline', label: 'Vigencia'},
          {key: 'is_active', label: 'Status'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      filters: false,
      toasts: [],
      providers: [],
      providersOptions: [],
      providerSelected: "",
      challenge_id: 0,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      },
      TYPE_LABELS: {
        video: 'Capacitación',
        sales: 'Venta Mínima',
        customers: 'Clientes Mínimos',
        boxes: 'Cajas Mínimo',
        boxes_and_customers: 'Cajas & Clientes',
        objectives: 'Objetivos',   // clave correcta
        objetives: 'Objetivos',    // alias por si llega mal escrito
      }
    }
  },
  mounted: async function() {
    let response = await providers_ws.get(); 

    if(response.type == "success"){
      this.providers = response.data;

      this.providersOptions = await this.$parseSelectOptionsOrdered(this.providers, "id", "name", [{value: '0', label: 'Todos los Proveedores'}]);
    }
  },
  methods: {
    toggleFilters () {
      this.filters = !this.filters;
    },
    typeLabel(t) {
      // 1) Si está en el mapa, úsalo
      if (t && this.TYPE_LABELS[t]) return this.TYPE_LABELS[t];
      // 2) Fallback decente: convierte snake_case/kebab a "Capitalizado"
      if (!t) return '-';
      const s = String(t).replace(/[_-]+/g, ' ').trim();
      return s ? s.charAt(0).toUpperCase() + s.slice(1) : '-';
    },
    async changeFilters () {
      this.loading();

      let filters = this.getFilters();
      let response = await ws.getFiltered(filters);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.loaded();
    },
    getFilters(){
      let filters = {
        provider : this.providerSelected
      };

      return filters;
    },
    showChallenge (item) {
      router.push({path: '/challenges/'+item.id+'/view'});
    },
    async storeModal () {
      await this.$refs.challengeModal.storeModal();
    },
    updateModal (item) {
      this.$refs.challengeModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Promoción", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        let data = response.data;
        this.changeFilters();
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        let data = response.data;
        this.changeFilters();
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.changeFilters();
      }

      this.showToast(response.type, response.message);
    },
    async deactiveProcess(id) {
      let response = await ws.deactive({id: id});
      
      if(response.type == "success"){
        this.changeFilters();
      }

      this.showToast(response.type, response.message);
    },
    async reactiveProcess(id) {
      let response = await ws.reactive({id: id});
      
      if(response.type == "success"){
        this.changeFilters();
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
